import APIV5 from '~/models/api';
import SchemaNode from '~/scripts/services/model/schema-node';
import _ from 'lodash-es';
import $ from 'jquery';

export default class ClassDesignerNodeEditorController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} NodeService
	 * @param {any} Notification
	 */
	constructor(
		$scope,
		$timeout,
		$translate,
		NodeService,
		Notification,
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;

		/** @type {string} */
		this.btntitle = '';

		/** @type {boolean} */
		this.classExists = false;

		/** @type {boolean} */
		this.create = false;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/components/class-designer/editor/class-designer-editor.controller').default} */
		this.editor = null;

		/** @type {?(import('angular').IFormController)} */
		this.form = null;

		this.isaNodeCreate = false;

		this.newNode = undefined;

		/** @type {boolean} */
		this.nodeClassChecking = false;

		/** @type {?SchemaNode} */
		this.schemaNode = null;

		/**
		 * @type {?{
		 *   modified: boolean,
		 *   node: SchemaNode,
		 *   options: import('~/scripts/services/model/class-designer').DesignerPanelOptions
		 * }}
		 */
		this.selected = null;

		/** @type {string} */
		this.tab = 'info';

		/** @type {?string} */
		this.title = null;

		/** @type {any} */
		this.tmp = {
			autoLinks: false,
			autoNodes: false,
			kdata:     {},
			validate:  true,
		};
	}

	async cancel() {
		if (this.editor?.tab) {
			if (this.schemaNode && this.selected?.options.create) {
				// @ts-ignore
				await this.editor.tab.nodeDelete(this.schemaNode, this.selected.modified);
			}
			if (this.editor.tab.selected.length > 0 && this.selected) {
				this.editor.tab.unselectAll();
			}
		}
		this.selected = null;
		this.schemaNode = null;
	}

	async nodeClassCheck() {
		if (this.nodeClassChecking && this.schemaNode?.node.isa.objid) {
			try {
				const result = await APIV5.instance.get(
					{ elt_kid: this.schemaNode.node.isa.objid },
					{ id: 'modal-class-designer-node.node-class-check' },
				);
				this.nodeClassChecking = false;
				// eslint-disable-next-line no-underscore-dangle
				this.classExists = result[this.schemaNode.node.isa.objid]._exist_ === 1;
			}
			catch {
				this.nodeClassChecking = false;
				this.classExists = false;
			}
		}
	}

	/**
	 * @param {string} name
	 */
	nodeCreate(name) {
		this.schemaNode?.node.setName(name);
		this.create = false;
		this.$timeout(() => {
			this.form?.$setDirty();
		});
	}

	/**
	 * @param {any} item
	 */
	async nodeSelect(item) {
		const schemaNode = this.editor?.tab?.schema.schemaNodes.find(
			(/** @type {SchemaNode} */ snode) => item.kid === snode.node.kid,
		);
		if (schemaNode) {
			// This node already exists in the schema!
			this.schemaNode = schemaNode;
			if (this.schemaNode) {
				this.schemaNode.existK = true;
			}
		}
		else if (this.schemaNode) {
			const node = await this.NodeService.load(item.kid, null, null, ['object']);
			_.extend(this.schemaNode.node, node);
			this.title = this.schemaNode.node.getName() || null;
			this.schemaNode.existK = true;
		}

		if (this.schemaNode) {
			await this.editor?.tab?.nodeUpdate(this.schemaNode);
		}
	}

	submit() {
		if (this.schemaNode?.node.repre.length === 0) {
			this.Notification.error({
				title:     this.$translate.instant('error.title'),
				message:   this.$translate.instant('error.missing-repre'),
			});
		}
		else if (this.schemaNode?.node.kid?.trim() === 'K_NODE;') {
			this.Notification.error({
				title:     this.$translate.instant('error.title'),
				message:   this.$translate.instant('error.missing-id'),
			});
		}
		else if (this.schemaNode && this.editor?.tab) {
			this.editor.tab.nodeUpdate(this.schemaNode);
		}

		// _.extend(this.#originalNode, this.node);
		// this.$uibModalInstance.close({
		// 	type:       this.action,
		// 	schemaNode: this.schemaNode,
		// 	autoLinks:  this.tmp.autoLinks,
		// 	autoNodes:  this.tmp.autoNodes,
		// });
	}

	updateAutoLinks() {
		if (this.selected?.options.autoNodes) {
			this.selected.options.autoLinks = true;
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.selected) {
			this.schemaNode = this.selected ? _.cloneDeep(this.selected.node) : null;
			this.create = this.selected?.options.create || false;
			this.btntitle = this.create ? this.$translate.instant('common.create') : this.$translate.instant('common.modify');
			this.isaNodeCreate = this.selected?.options?.isaNodeCreate ?? false;
			this.classExists = !this.isaNodeCreate;
			this.nodeClassChecking = this.isaNodeCreate;
			this.tab = this.selected?.options.tab || 'info';

			if (this.selected?.options.create) {
				this.title = this.schemaNode?.node.objtype === 'CLASS'
					? this.$translate.instant('designer.new-class')
					: this.$translate.instant('designer.new-object');
			}
			else {
				this.title = this.schemaNode?.node.getName() || null;
				if (!this.title) {
					this.title = this.$translate.instant('designer.node-no-name');
				}
			}

			this.$timeout(async () => {
				if (this.isaNodeCreate && !this.classExists) {
					this.form?.$setDirty();
					await this.nodeClassCheck();
				}
				if (this.selected?.options.create) {
					$('class-designer-node-editor .mf:visible > input').trigger('focus');
				}
			});
		}
	}

	$onInit() {
		/** @type {SchemaNode} */
		// this.schemaNode = new SchemaNode(_.cloneDeep(schemaNode.node));
		// this.schemaNode.existK = schemaNode.existK;
		// this.schemaNode.id = schemaNode.id;
		// this.schemaNode.readOnly = schemaNode.readOnly;
		// this.schemaNode.shape = schemaNode.shape;
		// this.schemaNode.x = schemaNode.x;
		// this.schemaNode.y = schemaNode.y;

		this.$scope.$watch('$ctrl.form.$dirty', () => {
			if (this.selected && this.form) {
				this.selected.modified = this.form.$dirty;
			}
		});

		this.$scope.$on('admin-class-designer-submit-node', () => this.submit());
	}
}
